import { z } from "zod";

export type UserAddress = {
  country: string;
  countryCode: string;
  street: string | null;
  city: string | null;
  state: string | null;
  stateCode: string | null;
  postalCode: string | null;
  county: string | null;
};

export const UserAddressSchema = z.object({
  city: z.nullable(z.string()),
  country: z.string(),
  countryCode: z.string(),
  county: z.nullable(z.string()),
  postalCode: z.nullable(z.string()),
  state: z.nullable(z.string()),
  stateCode: z.nullable(z.string()),
  street: z.nullable(z.string()),
});
